module.exports = __webpack_public_path__ + "static/imagen_04-ad8126598246d69f0abfcd59678d9d12.jpg";